import { ModuleWithProviders } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginComponent } from 'app/components/login/login.component';
import { VerifyComponent } from 'app/components/verify/verify.component';
import { ForgotPasswordComponent } from 'app/components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from 'app/components/reset-password/reset-password.component';
import {LoginSuspendedComponent} from 'app/components/login/login-suspended/login-suspended.component';
import {NotAuthorizedComponent} from 'app/components/not-authorized/not-authorized.component';
import {SessionExpiredComponent} from 'app/components/session-expired/session-expired.component';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [AuthGuard] },
  { path: 'login/:fail', component: LoginComponent },
  { path: 'verify', component: VerifyComponent, canActivate: [AuthGuard] },
  { path: 'verify/:fail', component: VerifyComponent },
  { path: 'forgotPassword', component: ForgotPasswordComponent },
  { path: 'resetPassword', component: ResetPasswordComponent },
  { path: 'suspended', component: LoginSuspendedComponent },
  { path: 'sessionExpired', component: SessionExpiredComponent },
  { path: 'notAuthorized', component: NotAuthorizedComponent },
  { path: '**', redirectTo: '/login', pathMatch: 'full' }
];

// tslint:disable-next-line:max-line-length
export const AppRoutingModule: ModuleWithProviders<RouterModule> = RouterModule.forRoot(routes, { useHash: false, preloadingStrategy: PreloadAllModules });
